import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import timeSince from "../../common/utils/timeSince";

const TimeSince = ({ date }) => {
  const [{ description, timeout }, setTimeSinceDesc] = useState(
    timeSince(date)
  );

  useEffect(() => {
    const timeoutSub = setTimeout(() => {
      setTimeSinceDesc(timeSince(date));
    }, 20000);

    return () => {
      clearTimeout(timeoutSub);
    };
  }, [timeout]);

  return date ? (
    <div
      data-tooltip={date.toLocaleString()}
      data-tooltip-delay={700}
      data-tooltip-opacity={0.9}
    >
      <div className="tw-text-coolGray-600 tw-text-xs font-helvetica">
        {description}
      </div>
    </div>
  ) : null;
};

TimeSince.propTypes = {
  date: PropTypes.instanceOf(Date),
};

TimeSince.defaultProps = {
  date: null,
};

export default React.memo(TimeSince);
